export function ImagePreview(props: { url: string; }) {
    return (
        <div className="d-flex justify-content-center h-100 w-100" style={{overflow: 'scroll'}}>
            <div>
                <img
                    src={props.url}
                    alt='Preview' />
            </div>
        </div>
    );
}
